namespace Matrix.Workflow {
    export interface QueueTypeRow {
        QueueTypeCode?: string;
        Description?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace QueueTypeRow {
        export const idProperty = 'QueueTypeCode';
        export const nameProperty = 'Description';
        export const localTextPrefix = 'Workflow.QueueType';
        export const lookupKey = 'Workflow.QueueType';

        export function getLookup(): Q.Lookup<QueueTypeRow> {
            return Q.getLookup<QueueTypeRow>('Workflow.QueueType');
        }
        export const deletePermission = 'DataAdmin:WorkflowQueueType';
        export const insertPermission = 'DataAdmin:WorkflowQueueType';
        export const readPermission = 'Read:WorkflowQueueType';
        export const updatePermission = 'DataAdmin:WorkflowQueueType';

        export declare const enum Fields {
            QueueTypeCode = "QueueTypeCode",
            Description = "Description",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
